<template>
    <div>
        <ul class="v-breadcrumbs vindome-breadcrumbs">
            <li class="v-breadcrumbs__item__home">
                <nuxt-link :to="localePath('/')" class="v-breadcrumbs__item">Vindome</nuxt-link>
            </li>
            <li class="v-breadcrumbs__divider">&gt;</li>
            <li>
                <span class="v-breadcrumbs__item">Start Investing</span>
            </li>
        </ul>
        <main v-if="mobileCheck">
            <section class="slogan">
                <div class="main-title">Start investing</div>
                <div class="main-subtitle">You must be a registered user before investing</div>
            </section>

            <section id="live-market">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">Live Market</h2>
                    <div class="title-border"></div>
                    <div class="live-market-info">Live Market connects wine investors and collectors globally allowing you to buy and sell wines in real time. Two options exist to buy wine on the Live Market: Price Listed and Place a Bid. The platform allows you to filter wines by country, region, appellation, vintage, enprimeur, bottles, colour, producer and price.</div>

                    <WineMarketHome></WineMarketHome>
                    <nuxt-link style="margin-top: 40px;" :to="localePath('/trading-desk')" :class="($i18n.locale.toLowerCase() === 'de' || $i18n.locale.toLowerCase() === 'fr') ? 'browse-market-btn-de' : 'browse-market-btn'">{{ $t('popular-wines2') }}</nuxt-link>
                </div>
            </section>

            <section id="top-collections">
                <div class="container home-collections-container">
                    <h2 class="home-title">Vindome's Collections</h2>
                    <div class="title-border"></div>
                    <div class="live-market-info">Our carefully created wine Collections make creating a balanced portfolio easy. These collections are created by our wine investment experts taking into consideration different budgets and investment horizons.</div>
                    <HomeTopCollections class="home-collections-container" :collections-list="topCollectionItems"></HomeTopCollections>
                    <nuxt-link :to="localePath('/collections')" class="browse-coll-btn">{{ $t('discover-all-collections') }}</nuxt-link>
                </div>
            </section>

            <section id="en-primeur">
                <h2 class="home-title">En Primeur</h2>
                <div class="title-border"></div>
                <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>
                <a href="/trading-desk/EnPrimeur" style="margin-top: 40px;" :class="($i18n.locale.toLowerCase() === 'de' || $i18n.locale.toLowerCase() === 'fr') ? 'browse-market-btn-de' : 'browse-market-btn'">{{ $t('see-all-enprimeur') }}</a>
            </section>

        </main>
        <main v-else>
            <section class="slogan">
                <div class="main-title">Start investing</div>
                <div class="main-subtitle">You must be a registered user before investing</div>
            </section>

            <section id="live-market">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">Live Market</h2>
                    <div class="title-border"></div>
                    <div class="live-market-info">Live Market connects wine investors and collectors globally allowing you to buy and sell wines in real time. Two options exist to buy wine on the Live Market: Price Listed and Place a Bid. The platform allows you to filter wines by country, region, appellation, vintage, enprimeur, bottles, colour, producer and price.</div>

                    <WineMarketHome></WineMarketHome>
                    <nuxt-link style="margin-top: 40px;" :to="localePath('/trading-desk')" :class="($i18n.locale.toLowerCase() === 'de' || $i18n.locale.toLowerCase() === 'fr') ? 'browse-market-btn-de' : 'browse-market-btn'">{{ $t('popular-wines2') }}</nuxt-link>
                </div>
            </section>

            <section id="top-collections">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">Vindome's Collections</h2>
                    <div class="title-border"></div>
                    <div class="live-market-info">Our carefully created wine Collections make creating a balanced portfolio easy. These collections are created by our wine investment experts taking into consideration different budgets and investment horizons.</div>

                    <HomeTopCollections class="home-collections-container" :collections-list="topCollectionItems"></HomeTopCollections>
                    <nuxt-link :to="localePath('/collections')" class="browse-coll-btn">{{ $t('discover-all-collections') }}</nuxt-link>
                </div>
            </section>

            <section id="en-primeur">
                <div class="container1366 padding200 padding80">
                    <h2 class="home-title">En Primeur</h2>
                    <div class="title-border"></div>
                    <div class="live-market-info">Also known as Wine Futures, En Primeur refers to the process of buying wines in the barrels before they are bottled. Wines are purchased exclusive of Duty and VAT and usually bottles are physically available 18-24 months after release.</div>
                    <div class="latest-offers-wrapper">
                        <HomePopularWines v-if="popularEnWines.length" :wines-list="popularEnWines"></HomePopularWines>

                        <nuxt-link :to="localePath('/trading-desk/EnPrimeur')" :class="($i18n.locale.toLowerCase() === 'de' || $i18n.locale.toLowerCase() === 'fr') ? 'browse-market-btn2-de' : 'browse-market-btn2'">{{ $t('see-all-enprimeur') }}</nuxt-link>
                    </div>
                </div>
            </section>
        </main>

        <section id="reg-section" v-if="!isLogged">
            <div class="container1366 padding200 padding80">
                <h2 class="home-title">Register now</h2>
                <div class="title-border"></div>
                <div class="live-market-info">Join Thousand of wine investors for free</div>

                <div class="reg-wrapper">
                    <div class="guide-reg-wrapper" v-if="!nextStep">
                        <div class="reg-container">
                            <div class="left-reg-column">
                                <v-flex>
                                    <span class="login-label">{{ $t('myprofile1') }} *</span>
                                    <v-text-field
                                        id="regFName"
                                        ref="regFName"
                                        v-model="regFName"
                                        class="email-input"
                                        :rules="[rules.required]"
                                        :error="$v.regFName.$error"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <span class="login-label">{{ $t('myprofile2') }} *</span>
                                    <v-text-field
                                        v-model="regLName"
                                        class="email-input"
                                        :rules="[rules.required]"
                                        :error="$v.regLName.$error"
                                    ></v-text-field>
                                </v-flex>
                            </div>
                            <div class="right-reg-column">
                                <v-flex>
                                    <span class="login-label">Email *</span>
                                    <v-text-field
                                        ref="email"
                                        v-model="regEmail"
                                        class="email-input"
                                        :rules="[rules.required, rules.emailValid]"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <span class="login-label">Password *</span>
                                    <v-text-field
                                        ref="regPassword"
                                        v-model="regPassword"
                                        :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[rules.required, rules.min]"
                                        :type="secureRegPassword ? 'password' : 'text'"
                                        name="input-10-1"
                                        hint="At least 8 characters"
                                        counter
                                        @click:append="secureRegPassword = !secureRegPassword"
                                        v-on:keyup.enter="registration"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </div>
                            <div class="mid-reg-column">
                                <v-checkbox  v-model="checked18" :label="$t('register-confirm18')"></v-checkbox>
                                <v-checkbox v-model="checkedTerms" class="check-terms">
                                    <div slot="label">
                                        {{ $t('register-terms') }}
                                    </div>
                                </v-checkbox>
                                <v-checkbox v-model="checkedNews" :label="$t('register-news')" class="check-terms"></v-checkbox>
                                <v-flex>
                                    <div class="errors-container2" v-if="errorMsg !== ''">
                                        <p>{{ errorMsg }}</p>
                                    </div>
                                </v-flex>
                            </div>
                            <v-flex>
                                <div class="browse-coll-btn login-submit" v-on:click="registration">Sign up for free</div>
                            </v-flex>
                        </div>
                    </div>
                    <div class="login-inner-container" v-else>
                        <div class="login-success">
                            <h2>Account created successfully</h2>
                            <div class="additional-info">
                                Check your email for an account activation link!
                            </div>
                        </div>

                        <div class="login-success-btn-wrapper">
                            <v-btn class="btn-primary btn-bid-proceed" v-on:click="goToLogin">OK</v-btn>
                            <v-btn class="btn-bid-cancel" v-on:click="resendMail">Resend email</v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import HomeTopCollections from "../components/home/HomeTopCollections";
import WineMarketHome from "../components/WineMarketHome";
import HomePopularWines from "../components/home/HomePopularWines";
import {GMarket, GOrders, GUser} from "@/store/getters";
import {AAuth, AMarket, AOrders} from "@/store/actions";
import {GCommon} from "@/store/getters";
import {email, minLength, required} from "vuelidate/lib/validators";

export default {
    name: 'StartInvesting',
    head: {
        title: 'Start Investing in Fine Wine | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'home page-start-investing'
        }
    },
    validations: {
        regFName: {
            required
        },
        regLName: {
            required
        },
        regEmail: {
            required,
            email
        },
        regPassword: {
            required,
            minLength: minLength(8)
        }
    },
    components: {
        HomeTopCollections, WineMarketHome, HomePopularWines
    },
    data(){
        return {
            collectionItems: [],
            topCollectionItems: [],
            moreCollectionsItems: [],
            popularEnWines: [],
            regEmail: '',
            regPassword: '',
            regFName: '',
            regLName: '',
            countryId: 224,
            checkedTerms: false,
            checked18: false,
            checkedNews: true,
            secureRegPassword: true,
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
            rules: {
                required: value => !!value || 'Required.',
                min: value => value.length >= 8 || 'Min 8 characters',
                emailValid: value => this.isEmailValid(value) || 'Invalid email'
            },
            errorMsg: '',
            nextStep: false
        }
    },
    computed: {
        ...mapGetters({
            collectionsList: GOrders.GET_COLLECTIONS,
            topCollectionsList: GOrders.GET_TOP_COLLECTIONS,
            collectionsListLength: GOrders.GET_COLLECTIONS_LENGTH,
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            wineItems: GMarket.GET_WINES,
            topEnWines: GMarket.GET_TOP_EN_WINES,
            isLogged: GUser.GET_USER_LOGGED
        }),
        topCollectionIds() {
            let _list = [];
            this.topCollectionsList.forEach(el => {
                _list.push(el.collectionId)
            });
            return _list
        },
        popularEnWinesIds() {
            let _list = [];
            this.topEnWines.forEach(el => {
                _list.push(el.wineId)
            });
            return _list
        }
    },
    methods: {
        isEmailValid(email) {
            return this.reg.test(email)
        },
        goToLogin() {
            this.$router.push(this.localePath({path: '/login'}));
        },
        resendMail() {
            this.sendMail(this.regEmail)
        },
        registration() {
            this.$v.regFName.$touch();
            this.$v.regLName.$touch();
            if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                if (this.checkedTerms && this.checked18) {
                    this.isLoading = true;
                    let payload = {
                        email: this.regEmail,
                        password: this.regPassword,
                        confirmPassword: this.regPassword,
                        firstname: this.regFName,
                        lastname: this.regLName,
                        countryId: this.countryId,
                        phoneNumber: '',
                        name: '',
                        enabledNotification: this.enabledNotification === true ? 1 : 0,
                        newsletter: this.checkedNews
                    };
                    this.signup(payload).then(res => {
                        if (res.reasonPhrase === "Created") {
                            this.nextStep = true;
                        }

                        this.$gtm.push({ event: "registration" });
                        window.fbq('track', 'CompleteRegistration');
                        window.uetq = window.uetq || [];
                        window.uetq.push("event", "signup", {});
                        this.$gtm.push({
                            'event': 'UETRegistration',
                            'ecomm_pagetype': 'conversion'
                        });
                    }).catch(err => {
                        this.isLoading = false;
                        if (err.data.errors) {
                            if (err.data.errors.Email.length) {
                                err.data.errors.Email.forEach(err => {
                                    this.errorMsg = err;
                                })
                            } else if (err.data.errors.GeneralError.length) {
                                err.data.errors.GeneralError.forEach(err => {
                                    this.errorMsg = err;
                                })
                            } else {
                                this.errorMsg = 'Unexpected behavior. Please check your internet connection or try again later.';
                            }
                        }
                    })
                } else {
                    this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                }
            } else {
                this.errorMsg = 'Please fill the above information.';
            }

        },
        ...mapActions({
            signup: AAuth.REG_USER,
            sendMail: AAuth.SEND_MAIL
        })
    },
    mounted(){
        this.$store.dispatch(AOrders.GET_TOP_COLLECTIONS, this.$i18n.locale);

        this.collectionItems = [];
        this.$store.dispatch(AOrders.GET_COLLECTIONS, this.$i18n.locale).then(() => {
            this.collectionItems = this.collectionsList;

            let homeCtrl = this;
            let total = 0;
            this.collectionItems.forEach(item => {
                if (homeCtrl.topCollectionIds.indexOf(item.id) < 0 && total < 6 && !item.isGiftDelivery) {
                    total += 1;
                    homeCtrl.moreCollectionsItems.push(item)
                }
                if (homeCtrl.topCollectionIds.indexOf(item.id) > -1) {
                    homeCtrl.topCollectionItems.push(item)
                }
            })
        });

        this.$store.dispatch(AMarket.GET_TOP_EN_WINES).then(() => {
            let homeCtrl = this,
                addedWines = 0;

            if (this.wineItems.length) {
                this.wineItems.forEach(wine => {
                    if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1 && addedWines < 10) {
                        homeCtrl.popularEnWines.push(wine);
                        addedWines++
                    }
                })
            } else {
                setTimeout(() => {
                    this.wineItems.forEach(wine => {
                        if (homeCtrl.popularEnWinesIds.indexOf(wine.wineId) > -1 && addedWines < 10) {
                            homeCtrl.popularEnWines.push(wine);
                            addedWines++
                        }
                    })
                }, 1000)
            }
        });
    }
};
</script>

<style scoped>
.slogan {
    height: 380px;
    padding-top: 80px;
    position: relative;
    background: linear-gradient(180deg, #00304D 0%, rgba(0, 48, 77, 0) 100%), url('../assets/home/start-investing.png') no-repeat center;
    background-size: cover;
}
.main-title {
    color: #ffffff;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 36px;
    line-height: 44px;
    padding: 105px 0 24px 0;
    text-transform: capitalize;
    text-align: center;
}
.main-subtitle {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: normal;
    color: #FFFFFF;
    max-width: 918px;
    margin: 0 auto;
}
.home-title-wine {
    text-align: center;
    font-weight: 400;
    font-size: 40px;
    line-height: 47px;
    margin: 24px auto 40px;
}
.browse-market-btn {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 330px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    display: block;
    text-align: center;
    margin: 0 auto;
    text-decoration: none;
}
.browse-market-btn2 {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 205px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    display: block;
    text-align: center;
    margin: 0 auto;
    text-decoration: none;
}
.browse-market-btn2-de {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 250px;
    height: 36px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    display: block;
    text-align: center;
    margin: 0 auto;
    text-decoration: none;
}
.browse-market-btn-de {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    padding: 8px 16px;
    width: 330px;
    height: 56px;
    background: #004F7F;
    border-radius: 8px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    display: block;
    text-align: center;
    margin: 0 auto;
    text-decoration: none;
}
.home-section1-btn1 {
    padding: 8px 16px;
    height: 36px;
    background: #ffffff;
    border-radius: 8px;
    color: #004F7F;
    display: inline-block;
    vertical-align: top;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    box-sizing: border-box;
    margin-top: 16px;
}
h2 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #002840;
    text-align: center;
}
.container1366 {
    position: relative;
    max-width: 1366px;
    margin: 0 auto;
    padding: 0 15px;
    box-sizing: border-box;
    z-index: 1;
}
.padding200 {
    padding: 0 200px;
}
.padding80 {
    padding-top: 80px;
    padding-bottom: 80px;
}
.title-border {
    width: 64px;
    height: 4px;
    background: #ECD9A7;
    margin: 24px auto 40px;
}
.latest-offers-wrapper {
    margin-top: 16px;
}
.home-title {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #002840;
    margin-bottom: 24px;
    position: relative;
    text-align: center;
}

.home-collections-container {
    max-width: 1214px;
    margin: 0 auto;
}
#top-collections, #reg-section {
    background-color: #f4f4f4;
}
.live-market-info {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    color: #002840;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 16px auto 40px;
}
.browse-coll-btn {
    background: #004F7F;
    border-radius: 8px;
    color: #ffffff;
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    padding: 8px 16px;
    text-decoration: none;
    height: 36px;
    display: block;
    margin: 0 auto;
    width: 238px;
    text-align: center;
}
.browse-coll-btn:hover {
    cursor: pointer;
}
.reg-container {
    max-width: 624px;
    margin: 0 auto;
}
.right-reg-column, .left-reg-column {
    display: inline-block;
    width: calc(50% - 26px);
}
.left-reg-column {
    margin-right: 24px;
}
.mid-reg-column {
    width: 50%;
    margin: 24px auto;
}
.errors-container2 p {
    color: red;
    margin-top: 12px;
    text-align: center;
    margin-bottom: 0;
}
.login-success {
    background: url("../assets/how/ok.gif") no-repeat center top;
    background-size: 250px;
    padding-top: 280px;
}
.additional-info {
    text-align: center;
    margin: 32px auto;
}
.login-success-btn-wrapper {
    text-align: center;
}
.theme--light.v-btn.v-btn--has-bg.btn-bid-proceed {
    background: #004F7F;
    border-color: #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFFFFF;
    margin-right: 16px;
}

.theme--light.v-btn.v-btn--has-bg.btn-bid-cancel {
    border: 1px solid #004F7F;
    border-radius: 8px;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #004F7F;
}

@media (max-width: 767px) {
    .padding200 {
        padding: 0 16px;
    }
    .padding80, #top-collections, #en-primeur {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .right-reg-column, .left-reg-column, .mid-reg-column {
        display: block;
        width: 320px;
        margin: 0 auto;
    }
    .mid-reg-column {
        margin: 24px auto;
    }
}
</style>


<style>
.mid-reg-column label {
    font-family: "Montserrat", Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: normal;
    color: black;
}

@media(max-width: 767px) {
    .home.page-start-investing .home-top-collections .swiper-container {
        height: 440px !important;
        margin-bottom: 0;
    }
    .home.page-start-investing .home-wine-market {
        margin: 0;
    }
}
</style>
